import { TextField, TextFieldProps } from '@mui/material';

export const StyledInput: React.FC<TextFieldProps> = (props) => (
  <TextField
    sx={{ marginRight: '16px', marginBottom: '16px' }}
    size="small"
    spellCheck={false}
    autoComplete="off"
    {...props}
  />
);
